export const ProductsActionTypes = {
  GET: {
    PRODUCT_PENDING: "GET_PRODUCT_PENDING",
    PRODUCT_SUCCESS: "GET_PRODUCT_SUCCESS",
    PRODUCT_ERROR: "GET_PRODUCT_ERROR",

    PRODUCT_BY_ID_PENDING: "GET_PRODUCT_BY_ID_PENDING",
    PRODUCT_BY_ID_SUCCESS: "GET_PRODUCT_BY_ID_SUCCESS",
    PRODUCT_BY_ID_ERROR: "GET_PRODUCT_BY_ID_ERROR",
  },
  SET: {
    PRODUCT_FILTER: "SET_PRODUCT_FILTER",
  },
};
